import { useRouter } from 'next/router';
import { EMBED_PATH, PAGE_INDEX } from '@store/constants/routes';
import { AspenLayout } from '@store/components/layouts/AspenLayout';
import { MarketingLayout } from '@store/components/layouts/MarketingLayout';
import { ErrorLayout } from '@store/components/layouts/ErrorLayout';
import { useTranslation } from '@yoweb/next-i18next';
import { withPageTitle } from '@store/components/withPageTitle';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * The page displayed when the user navigates to an unknown route.
 * This page is statically rendered (enforced by Next.js) for performance reasons.
 */
var Page404 = function Page404() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var router = useRouter();
  var isEmbeddedRoute = router.asPath.startsWith(EMBED_PATH);

  var error = /*#__PURE__*/_jsx(ErrorLayout, {
    title: t('404.title'),
    subtitle: t('404.subtitle'),
    linkLabel: t('404.back-link-label'),
    href: PAGE_INDEX,
    image: "/images/illustrations/self-care.svg",
    imageDesktop: "/images/illustrations/self-care-spotlight.svg",
    imageHeight: 520,
    imageHeightMobile: 140,
    imageAlign: "start",
    imageAltText: t('404.alt-text'),
    isEmbedded: isEmbeddedRoute
  });

  if (isEmbeddedRoute) {
    return /*#__PURE__*/_jsx(AspenLayout, {
      children: error
    });
  }

  return /*#__PURE__*/_jsx(MarketingLayout, {
    bgColor: "base050",
    children: error
  });
};

Page404.layout = {
  type: 'none'
};
export default withPageTitle(Page404)({
  translationKey: '404.page-title',
  translationNS: 'common'
});